import {
  PAYMENT_STEPS,
  PAYMENT_STEPS_DO_NOT_EXCEED_GROUP,
  PAYMENT_STEP_KEYS,
  PAY_AS_YOU_GO_STEPS,
} from 'post-inspection/constants/improvements-report';
import { ReportPayment } from 'post-inspection/models/improvements-report';

type UseImprovementReportPaymentStepsParams = {
  isLegacyInvoicing?: boolean;
  inspectionType?: {
    isPreMoveOut: boolean;
    isOnboarding: boolean;
  };
  usesPayAsYouGoBilling?: boolean;
  isDoNotExceedGroup: boolean;
  isComplimentaryRepairsWithExclusivitySelected: boolean;
  canExclusivityBeSelected: boolean;
  homeownerReportPayment: ReportPayment;
};

export const useImprovementReportPaymentSteps = ({
  isLegacyInvoicing = false,
  inspectionType,
  isDoNotExceedGroup = false,
  isComplimentaryRepairsWithExclusivitySelected,
  canExclusivityBeSelected,
  homeownerReportPayment,
  usesPayAsYouGoBilling = false,
}: UseImprovementReportPaymentStepsParams): Record<
  'steps',
  typeof PAYMENT_STEPS
> => {
  if (usesPayAsYouGoBilling) {
    return { steps: PAY_AS_YOU_GO_STEPS };
  }

  const isHomeownerPaymentZero =
    homeownerReportPayment.monthlyPayment === 0 &&
    homeownerReportPayment.total === 0 &&
    homeownerReportPayment.groupDueNow === 0;

  if (isHomeownerPaymentZero) {
    return {
      steps: PAYMENT_STEPS.filter(
        (paymentStep) => paymentStep.key === PAYMENT_STEP_KEYS.PaymentMethod,
      ),
    };
  }

  if (
    canExclusivityBeSelected &&
    isComplimentaryRepairsWithExclusivitySelected
  ) {
    return {
      steps: PAYMENT_STEPS.filter(
        (paymentStep) => paymentStep.key === PAYMENT_STEP_KEYS.PaymentMethod,
      ),
    };
  }

  if (isDoNotExceedGroup) {
    return { steps: PAYMENT_STEPS_DO_NOT_EXCEED_GROUP };
  }

  if (isLegacyInvoicing || inspectionType?.isPreMoveOut) {
    return {
      steps: PAYMENT_STEPS.filter(
        (paymentStep) => paymentStep.key === PAYMENT_STEP_KEYS.Summary,
      ),
    };
  }

  return {
    steps: PAYMENT_STEPS,
  };
};
